<template>
  <v-container>
    <v-row id="about-us-container" class="ma-0" no-gutters>
      <v-col>
        <StaticBannerWithCurvedCard />
        <v-row class="ma-0 px-sm-4 px-md-10 px-lg-12">
          <v-col>
            <TemplateEvents />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StaticBannerWithCurvedCard from '@/components/homepage/StaticBannerWithCurvedCard';
import TemplateEvents from '@/components/homepage/TemplateEvents';

export default {
  name: 'AboutUs',
  components: {
    StaticBannerWithCurvedCard,
    TemplateEvents,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.scrollToTop();
    },
    scrollToTop() {
      const container = this.$el.querySelector('#about-us-container');
      if (container == null) {
        return;
      }
      container.scrollIntoView({ behavior: 'smooth' });
    },
  },
};
</script>
